<template>
  <div class="outer-div">
    <v-container style="position: relative;">
      <v-row class="" justify="start" >
        <v-col cols="10" sm="5" md="4"> 
          <SearchTenancyApplicant
            color="orange" 
            v-if="showSearchBar"
            @selectedApplicant="setApplicant" 
          />
          <v-btn text @click="clearSearch" v-else color="orange">
            <v-icon small left>mdi-account-search</v-icon>
            <span class="custom-transform-class text-none">New search</span>
          </v-btn>
        </v-col>
        <div id="page-title" class="orange--text">My applicants</div>
        <v-avatar id="buyerAvatar" :size="avatarSize" color="orange">
          <v-icon :size="avatarSize" dark>mdi-account-circle</v-icon>
        </v-avatar>
      </v-row>
      
      <v-progress-circular
        class="mx-auto mt-12"
        :size="100"
        v-if="loading"
        color="primary"
        indeterminate
      ></v-progress-circular> 

      <v-row class="">
        <v-col cols="12" sm="8" offset-sm="2" >
          <transition name="fade" mode="out-in">
            <v-card v-if="applicant" outlined>
              <v-card-text>
                <v-row align="center">
                  <v-col class="text-center" cols="12" sm="4">
                    <v-avatar :size="cardAvatar" color="orange lighten-2">
                      <v-icon :size="cardAvatar" dark>mdi-account-circle</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col class="text-center text-sm-left" cols="12" sm="8">
                    <span class="text-subtitle-1 mr-1 font-weight-light" v-if="applicant.Title">{{applicant.Title}}</span>
                    <span class="text-h5">{{ applicant.Forename}} {{ applicant.Surname}}</span>
                    <p class="mb-0 text-subtitle-1">{{ applicant.EmailAddress }}</p>
                    <p class="mt-0 text-subtitle-1">{{ applicant.MobilePhone }}</p>
                    <v-divider class="my-3"></v-divider>

                    <p class="mb-0 font-weight-light">Latest move date: 
                      <span class="font-weight-regular" v-if="applicant.LatestMoveDate">{{ applicant.LatestMoveDate | dateFormatted}}</span>
                      <span v-else>n/a</span>
                    </p>
                    <p class="font-weight-light my-0">Max rent: 
                      <span class="font-weight-regular" v-if="applicant.MaxRent">{{ applicant.MaxRent | filterPriceGlobal }}</span>
                      <span v-else>n/a</span>
                    </p>
                    <span class="mr-5 font-weight-light">Min beds: 
                      <span class="font-weight-regular" v-if="applicant.MinimumBeds">{{ applicant.MinimumBeds }}</span>
                      <span v-else>n/a</span>     
                    </span>
                    <span class="font-weight-light">Max beds: 
                      <span class="font-weight-regular" v-if="applicant.MaximumBeds">{{ applicant.MaximumBeds }}</span>
                      <span v-else>n/a</span>     
                    </span>
                    <br>
                    <v-btn @click="bookAppointmentDialog = true" class="mt-3 px-0" color="light-blue lighten-2" text>
                      <v-icon left small>mdi-calendar-month</v-icon>
                      Book appointment
                    </v-btn>
                    <br>
                    <v-btn @click="toOnlineApplication" class="px-0" color="light-blue lighten-2" text>
                      <v-icon left small>mdi-card-account-details-outline</v-icon>
                      Online application
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </transition>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="bookAppointmentDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      persistent
      :overlay="false"
      transition="dialog-transition"
      width="650"
    >
      <CreateAppointment 
        @closeCreateComponent="bookAppointmentDialog = false"
        :selectedPersonProp="selectedPersonProp"
      />
    </v-dialog>
  </div>
</template>

<script>
import SearchTenancyApplicant from '@/components/Searches/SearchTenancyApplicant.vue';
import CreateAppointment from '@/components/Appointments/CreateAppointment.vue';
import moment from 'moment/src/moment'

export default {
  name: 'my-applicants',
  components: {
    SearchTenancyApplicant,
    CreateAppointment
  },
  data() {
    return {
      applicant: '',
      cardAvatar: 100,
      loading: false,
      showSearchBar: false,
      bookAppointmentDialog: false
    }
  },
  created(){
    this.$store.commit("EXPIRE_LOGIN");
    if(this.$store.state.user === ''){
      this.$router.push('/');
    }
  },
  methods: {
    clearSearch() {
      this.loading = false
      this.applicant = '',
      this.showSearchBar = true
    },
    setApplicant(applicant) {
      console.log(applicant)
      if(applicant.OID) {
        this.loading = true
        const id = applicant.OID

        this.$store.dispatch('getTenantDetails', id)
        .then( res => {
          this.loading = false
          this.applicant = {...res.data, OID: applicant.OID}
          this.showSearchBar = false
        })
        .catch( err => {
          console.log(err)
        })
      }
    },
    toOnlineApplication() {
      this.$store.commit('OffersApplications/SET_TENANCY_APPLICANT', this.applicant)
      this.$router.push('application')
    }
  },
  computed: {
    avatarSize() {
      if(this.$vuetify.breakpoint.sm) { return 700 }
      if(this.$vuetify.breakpoint.md) { return 750 }
      if(this.$vuetify.breakpoint.lg) { return 800 }
      if(this.$vuetify.breakpoint.xlOnly) { return 1000 }
      return 400
    },
    selectedPersonProp() {
      if(this.applicant) {
        return {
          OID: this.applicant.OID,
          Subject: `${this.applicant.Forename} ${this.applicant.Surname}`
        }
      }
      return ''
    }
  },
  filters: {
    dateFormatted(val) {
      return moment(val)
        .format("DD/MM/YYYY")
        
    },
  }
}
</script>

<style>
.outer-div {
  overflow-x: hidden; 
  overflow-y: hidden;
  min-height: 100vh;
}

#buyerAvatar {
  position: absolute !important;
  right: -130px;
  top: 150px;
  opacity: 5% !important;
}

#page-title { 
  font-size: 2.3rem;
  position: absolute;
  top: 110px;
  left: 40px;
  color: #2196F3;
  opacity: 5% !important; 
}

@media screen and (min-width: 768px) {
  #buyerAvatar {
    right: -150px;
  }

  #page-title { 
    font-size: 3rem;
    top: 150px;
    left: 30px;
  }
}

@media screen and (min-width: 1024px) {
  #page-title { 
    font-size: 4rem;
    top: 170px;
    left: 30px;
    /* color: red; */
  }

  #buyerAvatar {
    right: -180px;
  }
}

@media screen and (min-width: 1264px) {
  #page-title { 
    font-size: 6rem;
    top: 150px;
    left: 100px;
    /* color: green; */
  }

  #buyerAvatar {
    right: -200px;
  }
}

@media screen and (min-width: 1904px) {
  #page-title { 
    font-size: 8rem;
    top: 150px;
    left: 300px;
    /* color: red; */
  }

}
</style>